export default __webpack_public_path__ + "images/fa5e372631564d41a3801be2031e409a.png";